var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReserVationIcnRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_114_282",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#e33745"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_114_282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0579 11.5C10.7818 11.5 10.5579 11.7239 10.5579 12C10.5579 12.2761 10.7818 12.5 11.0579 12.5H17.0579C17.334 12.5 17.5579 12.2761 17.5579 12C17.5579 11.7239 17.334 11.5 17.0579 11.5H11.0579Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5579 10C10.5579 9.72386 10.7818 9.5 11.0579 9.5H16.0579C16.334 9.5 16.5579 9.72386 16.5579 10C16.5579 10.2761 16.334 10.5 16.0579 10.5H11.0579C10.7818 10.5 10.5579 10.2761 10.5579 10Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0579 13.5C11.7818 13.5 11.5579 13.7239 11.5579 14C11.5579 14.2761 11.7818 14.5 12.0579 14.5H17.0579C17.334 14.5 17.5579 14.2761 17.5579 14C17.5579 13.7239 17.334 13.5 17.0579 13.5H12.0579Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2771 5H6.7509C6.33406 5 5.96094 5.25857 5.81457 5.64888L2.06457 15.6489C1.81942 16.3026 2.3027 17 3.0009 17H8.5579L8.85232 18.2324C8.95985 18.6825 9.36217 19 9.82499 19H20.2771C20.6837 19 21.0227 18.7612 21.1812 18.428C21.2763 18.228 21.3065 17.9941 21.2473 17.7575L18.2473 5.75746C18.2385 5.72243 18.228 5.68823 18.2158 5.65493C18.1697 5.52955 18.1 5.41707 18.0124 5.32217C17.8277 5.12199 17.5639 5 17.2771 5ZM6.7509 6.81239L8.42697 15.9023H3.32688L6.7509 6.81239ZM17.0579 6.12402H7.69617L9.99219 17.7348L19.9052 17.7575L17.0579 6.12402Z",
    fill: "#e33745"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReserVationIcnRed);
export default __webpack_public_path__ + "static/media/ReserVationIcnRed.3a5ecebfbcee517157ba82854fcb8896.svg";
export { ForwardRef as ReactComponent };